import axios from 'axios'
import env from '../store/env'

export const woosmapRefererConfig = {
    headers: {
        Referer: env.defaultDomain
    }
}

type Props = {
    address?: string,
    coordinates?: {
        lattitude: string,
        longitude: string
    },
    setSuggestions?: (
        suggestions: {
            render: any,
            text: string
        }[]
    ) => void
}

const geocodeBaseUrl = 'https://api.woosmap.com/localities/geocode'

export async function getGeocodingFromWoosmap(
    props: Props
): Promise<{ results: any }> {
    const { address } = props
    if (!!address) {
        try {
            const uriAddress = encodeURI(address)
            const response = await axios.get(
                `${geocodeBaseUrl}?address=${uriAddress}&key=${env.woosmapPublicKey}`,
                woosmapRefererConfig
            )
            return response?.data
        } catch (error) {
            console.error('getGeocodingFromWoosmap has failed:', error)
        }
    }
    return { results: [] }
}

export async function getReverseGeocodingFromWoosmap(
    props: Props
): Promise<{ results: any }> {
    const { coordinates } = props
    if (!!coordinates) {
        try {
            const response = await axios.get(
                `${geocodeBaseUrl}?latlng=${coordinates.lattitude},${coordinates.longitude}&key=${env.woosmapPublicKey}`,
                woosmapRefererConfig
            )
            return response?.data
        } catch (error) {
            console.error('getReverseGeocodingFromWoosmap has failed:', error)
        }
    }
    return { results: [] }
}

export async function getCoordinatesFromWoosmap(
    address: any
): Promise<{ lat: number, lng: number }> {
    const data = await getGeocodingFromWoosmap({ address })
    return data.results[0].geometry.location
}

export async function getAddressFromWoosmap(
    lat: any,
    lng: any
): Promise<string | null> {
    const data = await getReverseGeocodingFromWoosmap({
        coordinates: { lattitude: lat, longitude: lng }
    })
    if (data.results.length > 0) {
        return data.results[0].formatted_address
    }
    return null
}
